import React from "react";
import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useOutletContext } from "react-router-dom";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import "Assets/css/MembGameRelLst.css";

const MembGameSvcMnyInqUi = () => {
    const langData: any = useOutletContext();
    const [membGameRelLstState, setMembGameRelLstState] = useState([]);
    
    useEffect(() => {
        MembGameRelLstApi().then((resp) => (
            setMembGameRelLstState(resp.yrelLst)
        ));
    }, [])
    
    return (
        <>
        <div className="membGameSvcRelLstWrap">
            <div className="membGameSvcMnyLpopTitlWrap">
                <h1>{langData && langData.MYPAGE_MAIN_GAME_MNY_TITL_00 || "보유 게임 머니"}</h1>
                <p>{langData && langData.MYPAGE_MAIN_GAME_MNY_DESC_00 || "현재 보유하고 있는 각 게임별 머니를 확인할 수 있습니다."}</p>
            </div>
            <div className="membGameSvcRelCardWrap membGameSvcRelCardLpopWrap">
                <ul>
                    {membGameRelLstState && membGameRelLstState.map((key: any, index: number) => (
                        <li key={index} className="membGameSvcRelCard">
                            <div className="gameSvcThmbImgWrap">
                                <img src={key.thmbUrl} alt={key.gameNm} />
                            </div>
                            <div className="membGameSvcRelCardTextWrap">
                                <div className="gameSvcTitl">
                                    <h1>{key.gameNm}</h1>
                                </div>
                                <div className="membGameSvcTotMnyWrap">
                                    <p>{langData && langData.MYPAGE_MAIN_GAME_MNY_LBL_00 || "보유 머니"}</p>
                                    <p className="totMnyText">{key.totMny}</p>
                                </div>
                                <div className="dFlex gap15">
                                    {/* <Link className="gameMnyPopBtn" to={`/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=${key.gameSvcCd}`} style={{textAlign: 'center'}}> */}
                                    {/* BBO로 들어와서 제대로 작동 안함 */}
                                    {/* <Link className="gameMnyPopBtn" to={`/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=KRBBO`} style={{textAlign: 'center'}}>
                                        <p>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}</p>
                                    </Link> */}
                                    {/* <button className="gameMnyPopBtn" onClick={()=>GameMnyPopFunc(`/GameMnyDpstPop?lang=${MgpStore.getState().LangSetState.Lang}`)}>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_00}</button> */}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        </>
    )
}

export default MembGameSvcMnyInqUi;